import * as React from "react";
import { useHistory } from "react-router-dom";
import { CoachOption, CoachPicker } from "@/containers/Coach/DesignStudio/components/CoachPicker";
import { ScopeToggle } from "@/containers/Coach/DesignStudio/components/ScopeToggle";
import { DesignStudioScope, useDesignStudioScope } from "@/containers/Coach/DesignStudio/DesignStudioScope";
import { PROMPT_STUDIO_TABS, DesignStudioHeader } from "@/containers/Coach/DesignStudio/components/DesignStudioHeader";
import { URLS } from "@/utils/routes";

export type AdminDesignStudioTab = "designs" | "backgrounds";

const TAB_URLS: Record<AdminDesignStudioTab, string> = {
  designs: URLS.admin.designStudio,
  backgrounds: URLS.admin.designStudioBackgrounds,
};

interface AdminDesignStudioHeaderProps {
  tab: AdminDesignStudioTab;
  /** The tab's own buttons, after the scope controls. */
  actions?: React.ReactNode;
  /** Runs instead of the plain store update, for tabs that reset their own filters on a scope change. */
  onScopeChange?(scope: DesignStudioScope): void;
  onCoachChange?(coach: CoachOption | null): void;
}

/**
 * The admin Design Studio section header: Designs | Backgrounds tabs and the Global | Coach scope
 * both tabs share.
 */
export const AdminDesignStudioHeader: React.FC<AdminDesignStudioHeaderProps> = ({
  tab,
  actions,
  onScopeChange,
  onCoachChange,
}) => {
  const history = useHistory();
  const { scope, coach, setScope, setCoach } = useDesignStudioScope();

  return (
    <DesignStudioHeader
      tabs={PROMPT_STUDIO_TABS}
      selectedTab={tab}
      onTabChange={key => key !== tab && history.push(TAB_URLS[key as AdminDesignStudioTab])}
      actions={
        <>
          <ScopeToggle scope={scope} onScopeChange={onScopeChange ?? setScope} />
          {scope === "coach" && <CoachPicker coach={coach} onCoachChange={onCoachChange ?? setCoach} />}
          {actions}
        </>
      }
    />
  );
};
